import { Routes } from '@angular/router'

import { FeatureType, RouteUtil } from '../shared'
import { AnalyticsComponent } from './analytics/analytics.component'
import { BidDashboardComponent } from './dashboard/bid-dashboard.component'
import { HeavyBidDataComponent } from './heavy-bid-data/heavy-bid-data.component'
import { AllHistoriesComponent } from './history/all-histories.component'
import { HistoriesComponent } from './history/histories.component'
import { HistoryValidationComponent } from './history/history-validation.component'
import { OutlooksComponent } from './outlook/outlooks.component'
import { RangesComponent } from './range/ranges.component'
import { CompetitorJobBidsComponent } from './competitor-job-bids/competitor-job-bids.component'
import { BidStatisticalAnalysisComponent } from './bid-statistical-analysis/bid-statistical-analysis.component'
import { FabShopStockProductsComponent } from './fab-shop-stock-products/fab-shop-stock-products.component'
import { ViewpointDataComponent } from './viewpoint-data/viewpoint-data.component'
import { BidRateDataComponent } from './bid-rate-data/bid-rate-data.component'

export const bidsRoutes: Routes = [
    {
        path: 'bids',
        children: [
            RouteUtil.Make('dashboard', BidDashboardComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('history', HistoriesComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('history-validation', HistoryValidationComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('all-histories', AllHistoriesComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('outlook', OutlooksComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('analytics', AnalyticsComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('bidranges', RangesComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('heavy-bid-data', HeavyBidDataComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('competitor-job-bids', CompetitorJobBidsComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('statistical-analysis', BidStatisticalAnalysisComponent, FeatureType.BidAnalyticsView),
            RouteUtil.Make('fab-shop-stock-products', FabShopStockProductsComponent, FeatureType.BidFabShopStockProductsView),
            RouteUtil.Make('viewpoint-data', ViewpointDataComponent, FeatureType.BidViewpointDataView),
            RouteUtil.Make('bid-rate-data', BidRateDataComponent, FeatureType.BidRateDataView),
        ],
    },
]
